import { useNavigate } from 'react-router-dom';
import { Layout, Dropdown, Space, Avatar, Typography, Button } from 'antd';
import { UserOutlined, LogoutOutlined, ArrowLeftOutlined, MenuOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectCurrentUser } from '@/store/auth/authSelectors';
import { logoutRequest } from '@/store/auth/authSlice';

const { Header } = Layout;
const { Text } = Typography;

interface TopHeaderProps {
  isMobile?: boolean;
  onMenuToggle?: () => void;
}

export default function TopHeader({ isMobile, onMenuToggle }: TopHeaderProps) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector(selectCurrentUser);

  const handleLogout = () => {
    dispatch(logoutRequest());
    navigate('/signin');
  };

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleLogout,
    },
  ];

  return (
    <Header
      style={{
        background: '#fff',
        padding: isMobile ? '0 12px' : '0 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: '1px solid #f0f0f0',
        height: 64,
      }}
    >
      <Space>
        {isMobile ? (
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={onMenuToggle}
            style={{ fontSize: 18 }}
          />
        ) : (
          <ArrowLeftOutlined
            onClick={() => navigate(-1)}
            style={{ fontSize: 16, cursor: 'pointer' }}
          />
        )}
      </Space>
      <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
        <Space style={{ cursor: 'pointer' }}>
          <Avatar icon={<UserOutlined />} size="small" />
          {!isMobile && <Text>{user?.name || 'Admin'}</Text>}
        </Space>
      </Dropdown>
    </Header>
  );
}
